<section class="contact" id="contact">
  <div class="contact-card">
    <div class="contact-heading">
      <span class="contact-tag">We're here to help</span>
      <h2>Send Us a Message</h2>
      <p>Fill out the form below and our team will get back to you as soon as possible.</p>
    </div>

    <form class="contact-form" (submit)="submit($event)">
      <div class="form-row">
        <div class="form-field">
          <label for="contact-name">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            placeholder="Your name"
            [ngModel]="name()"
            (ngModelChange)="name.set($event)"
            required
          />
        </div>
        <div class="form-field">
          <label for="contact-email">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            placeholder="you@example.com"
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            required
          />
        </div>
      </div>

      <div class="form-field">
        <label for="contact-message">Message</label>
        <textarea
          id="contact-message"
          name="message"
          rows="5"
          placeholder="How can we help?"
          [ngModel]="message()"
          (ngModelChange)="message.set($event)"
          required
        ></textarea>
      </div>

      <button type="submit" class="contact-submit">Send Message</button>
    </form>

    <p class="contact-alt">
      Or reach us directly on
      <a
        href="https://api.whatsapp.com/send/?phone=923000910043&text&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener"
        >WhatsApp</a
      >
      or
      <a href="mailto:hr@techcolleagues.com">hr&#64;techcolleagues.com</a>
    </p>
  </div>
</section>
